import * as React from "react";
import Loadable from "react-loadable";

export const PostModalLink = Loadable({
  loader: () => import("../../../../modules/post-modal").then((module) => module.PostModalLink) as Promise<any>,
  loading: () => <div/>,
});
